import React from "react";
import Footer from "../Footer/Footer";
import SimpleHeader from "../NewApp/SimpleHeader";
import "./Educational.css";

const posts = [
  {
    title: "Ֆինանսական մարկետներ, ֆոնդային բորսաներ և IPO",
    link: "https://girlsandfinances.substack.com/p/ipo?r=5c0o0o",
  },
  {
    title: "Որտե՞ղ կարող ենք ներդրումներ կատարել",
    link: "https://girlsandfinances.substack.com/p/3c4?r=5c0o0o",
  },
  {
    title: "Բաժնետոմսերի դասակարգում",
    link: "https://girlsandfinances.substack.com/p/3ff?r=5c0o0o",
  },
  {
    title: "Ակտիվ ներդրումային ռազմավորություններ",
    link: "https://girlsandfinances.substack.com/p/7dc?r=5c0o0o",
  },
  {
    title: "Պասիվ ներդրումային ռազմավարություններ",
    link: "https://girlsandfinances.substack.com/p/8fa?r=5c0o0o",
  },
  {
    title: "Հասկանանք թվերը (հեշտ լեզվով, մաս 1/2)",
    link: "https://girlsandfinances.substack.com/p/12?r=5c0o0o",
  },
  {
    title: "Հասկանանք թվերը (հեշտ լեզվով, մաս 2/2)",
    link: "https://girlsandfinances.substack.com/p/22?r=5c0o0o",
  },
  {
    title: "Ռիսկերի գնահատում (Մաս 1/2)",
    link: "https://girlsandfinances.substack.com/p/12-411?r=5c0o0o",
  },
  {
    title: "Ռիսկերի գնահատում (Մաս 2/2)",
    link: "https://girlsandfinances.substack.com/p/22-fe5?r=5c0o0o",
  },
  {
    title: "Պորտֆելի կառուցում (Մաս 1/3)",
    link: "https://girlsandfinances.substack.com/p/13?r=5c0o0o",
  },
  {
    title: "Պորտֆելի կառուցում (Մաս 2/3)",
    link: "https://girlsandfinances.substack.com/p/23?r=5c0o0o",
  },
  {
    title: "Պորտֆելի կառուցում (Մաս 3/3)",
    link: "https://girlsandfinances.substack.com/p/33?r=5c0o0o",
  },
  {
    title: "Բաժնետոմսերի սպլիտ և ռիվերս սպլիտ",
    link: "https://girlsandfinances.substack.com/p/632?r=5c0o0o",
  },
  {
    title: "Բաժնետոմսերի հետգնում, միավորումներ, spinoff-ներ",
    link: "https://girlsandfinances.substack.com/p/spinoff?r=5c0o0o",
  },
  {
    title: "Ինչպես օգտագործել Yahoo Finance-ը",
    link: "https://girlsandfinances.substack.com/p/yahoo-finance?r=5c0o0o",
  },
  {
    title: "5 ներդրումային հայտնի սխալներ",
    link: "https://girlsandfinances.substack.com/p/5-006?r=5c0o0o",
  },
  {
    title: "Ինչպես է աշխատում S&P 500-ը",
    link: "https://girlsandfinances.substack.com/p/s-and-p-500?r=5c0o0o",
  },
  {
    title: "Ի՞նչ են 10-K և 10-Q հաշվետվությունները",
    link: "https://girlsandfinances.substack.com/p/10-k-10-q?r=5c0o0o",
  },
];

const Educational: React.FC = () => (
  <div className="educational-wrapper">
    <SimpleHeader onHome={() => window.location.href = '/'} onResources={() => window.location.href = '/resources'} />

    <div className="educational-background">
      <div className="gradient-blob blob-1"></div>
      <div className="gradient-blob blob-2"></div>
    </div>

    <div className="educational-container">
      <div className="educational-header">
        <h1 className="educational-title">Կրթություն բաժնետոմսերում ներդրումների մասին</h1>
        <p className="educational-description">
          Սովորեք ներդրումների հիմունքները՝ բաժնետոմսերից և մարկետներից մինչև պորտֆելի կառուցում, ռիսկերի կառավարում և ներդրումային ռազմավարություններ
        </p>
      </div>

      <div className="educational-grid">
        {posts.map((post, idx) => (
          <a
            key={idx}
            href={post.link}
            target="_blank"
            rel="noopener noreferrer"
            className="educational-card"
          >
            <div className="card-number">{String(idx + 1).padStart(2, '0')}</div>
            <h3 className="card-title">{post.title}</h3>
            <div className="card-arrow">→</div>
          </a>
        ))}
      </div>
    </div>

    <Footer />
  </div>
);

export default Educational;
